import React from 'react';
import { CaretDownAshIcon, PersonAshIcon } from '@glu/icons-react';
import locale from '@glu/locale';
import { AccessibilityText } from '@glu/utilities-react';
import PropTypes from 'prop-types';
import useStyles from './UserLink.styles';

const UserLink = (props) => {
  const {
    username,
    subtext,
    avatar
  } = props;
  const classes = useStyles(props);

  return (
    <span className={classes.userLink}>
      <span className={classes.avatar}>
        {avatar || (
        <>
          <AccessibilityText>{locale.get('nav.accountAvatar')}</AccessibilityText>
          <PersonAshIcon className={classes.icon} title={locale.get('nav.open')} />
        </>
        )}
      </span>
      <span className={classes.content}>
        <span className={classes.username}>
          <span>{username}</span>
          <CaretDownAshIcon className={classes.icon} title={locale.get('nav.open')} />
        </span>
        {subtext && (
        <span className={classes.subtext}>
          {subtext}
        </span>
        )}
      </span>
    </span>
  );
};

export default UserLink;

UserLink.propTypes = {
  username: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  avatar: PropTypes.oneOf([PropTypes.func, PropTypes.shape({})])
};

UserLink.defaultProps = {
  avatar: undefined,
  subtext: undefined
};
